import pdfMake from 'pdfmake/build/pdfmake';

/**
 * @param {Function} predicate
 * @param {Function} onMatch
 * @constructor
 */
function MatchPair(predicate, onMatch)
{
    this.predicate = predicate;
    
    this.execute = function(node)
    {
        if (predicate(node))
            onMatch(node)
    }
}

/**
 * Executes all matchers against the node provided and its parents
 * @param node - Node to test against
 * @param {MatchPair[]} matchPairs
 */
function traverseParents(node, matchPairs) {
    var current = node;
    while (current)
    {
        matchPairs.forEach(function (matcher)
        {
            matcher.execute(current)
        });
        
        current = current.parentNode || undefined;
    }
}

/**
 * Traverses childNodes of childNodes passed. Matches to matching rules and then performs the passed function.
 * @param {(NodeList | HTMLCollection)} nodes
 *
 * @param matchingRules
 * @param {Number[]=} matchingRules.nodeTypes - Types of nodes to accept
 * @param {String[]=} matchingRules.nodeNames - Names of nodes to accept
 * @param {function[]=} matchingRules.otherMatches - Predicates to match against that don't fit the other scopes
 * @param {Boolean=} matchingRules.acceptAllChildren - Whether all nodes should be accepted regardless of others rules
 * @param {Boolean=} matchingRules.useChildren - Whether to use children over childNodes of the nodes
 *
 * @param {Function} onMatch - Callback invoked on matching nodes
 * @param {Object=} styling
 */
function traverseNodes(nodes, matchingRules, onMatch, styling)
{
    var predicates = [
        function(node)
        {
            if (matchingRules.nodeTypes)
                return matchingRules.nodeTypes.find(function (x) { return x == node.nodeType; });
            return false;
        },
        function (node)
        {
            if (matchingRules.nodeNames)
                return matchingRules.nodeNames.find(function (x) { return x == node.nodeName; });
            return false;
        },
        function (node)
        {
            if (matchingRules.otherMatches)
                return matchingRules.otherMatches.some(function (x) { return x(node) });
            return false;
        }
    ];
    
    var originalStyling = styling || {
        classList: [],
        nodeName: [],
        attributes: [],
        styleOptions: {},
        href: undefined
    };
    
    for (var i = 0; i < nodes.length; i++)
    {
        styling = JSON.parse(JSON.stringify(originalStyling));
        var node = nodes[i];
        
        styling.nodeName.push(node.nodeName);
        styling.href = (styling.href === undefined) ? node.href : (node.href === undefined) ? styling.href : node.href ;
        if (node.classList)
            for (var x = 0; x < node.classList.length; x++)
            {
                styling.classList.push(node.classList[x])
            }
        if (node.attributes)
            for (var x = 0; x < node.attributes.length; x++)
            {
                styling.attributes.push(node.attributes[x])
            }
        
        var styleOptions = getCssStyleMap(node);
        for (var field in styleOptions)
        {
            if (field !== 'length')
                styling.styleOptions[field] = styleOptions[field];
        }
        
        if (!node.parsedStyling)
            node.parsedStyling = styling;
        
        for (var x = 0; x < predicates.length; x++)
        {
            var key = predicates[x](node) || (matchingRules.acceptAllChildren && node);
            if (key)
            {
                onMatch(node, key);
                break;
            }
        }

        if (node && (matchingRules.useChildren) ? node.children :  node.childNodes || false)
            traverseNodes((matchingRules.useChildren) ? node.children :  node.childNodes, matchingRules, onMatch, styling)
    }
}

function formatPDF(doc, $scope)
{
	var parser = new DOMParser(),
		unicodeFontURL = `${window.location.origin}/webpack/fonts/Unicode-Upper.ttf`;

	pdfMake.fonts = {
		SourceSans:
		{
			normal: `${window.location.origin}/webpack/fonts/SourceSans-Regular.ttf`,
			bold: `${window.location.origin}/webpack/fonts/SourceSans-Bold.ttf`,
			italics: `${window.location.origin}/webpack/fonts/SourceSans-Italic.ttf`,
			bolditalics: `${window.location.origin}/webpack/fonts/SourceSans-BoldItalic.ttf`
		},
        Unicode:
		{
			normal: unicodeFontURL,
			bold: unicodeFontURL,
			italics: unicodeFontURL,
			bolditalics: unicodeFontURL
		}
	};
	
    pdfMake.tableLayouts = {
        logbook: {
            hLineWidth: function (index, node) {
                return (index === 0) ? 1 : 0
            },
            vLineWidth: function (index, node) {
                return (index === 1) ? 1 : 0
            }
        }
    };
    
    doc.styles.tableBodyEven.fillColor = '#ffffff';

    doc.defaultStyle.font = 'SourceSans';
    doc.content[1].table.body.forEach(function(row, index)
    {
        // Leaves headers alone
        if (index <= 0)
            return;

        for (var i = 0; i < row.length; i++)
        {
            var originalCell = row[i];

            var parsed = parser.parseFromString(originalCell.text, 'text/html');

            var matchingNodes = [];
            traverseNodes(parsed.children, {
                    nodeTypes: [3],
                    nodeNames: ['IMG', 'UL', 'OL', "TR", 'SPAN']
                },
                function(node, key) { matchingNodes.push({node: node, key: key})} );

            var tableNode = new TableNode(0, 1);
            doc.extra = {
                tableCount: 0
            };
            matchingNodes.forEach(function (matchedNode, index)
            {
                var cellItem = formatNode(matchedNode, doc, $scope);
                
                // Determines if the cell should be added to the table
                if (isValidNode(cellItem))
                    tableNode.addRow([cellItem], function(stackNode)
                    {
                        if (cellItem.fillColor)
                            stackNode.fillColor = cellItem.fillColor;
                    })
            });

            tableNode.trim();

            // Determines if the table is needed
            if (tableNode.getRowCount() > 1)
            {
                delete originalCell.text;
                tableNode.forEach(function(stackNode)
                {
                    stackNode.alignment = 'center'
                });
                
                var tableCell = tableNode.getTableCell();
                tableCell.style = originalCell.style;
                tableCell.layout = 'noBorders';
                tableCell.alignment = 'center';
                
                row[i] = tableCell;
                continue;
            }
            else if (!tableNode.isEmpty())
            {
                var x = tableNode.getBody()[0][0].pop();

                // Assigns added values from the cell Item to the original node
                if (Object.keys(x).length > 0)
                {
                    delete originalCell.text;
                    for (var attrib in x)
                    {
                        originalCell[attrib] = x[attrib];
                    }
                }
            }
            if (originalCell.text && typeof originalCell.text === 'string')
                originalCell.text = originalCell.text.replace(/<[^>]*>?/gm, '');
            
            // Protect against empty cells with formatting which causes PDFMake to fail
            if (!(originalCell.text || originalCell.image))
            {
                row[i] = { style:originalCell.style, text: ' ' };
            }
        }
    });
}

/**
 * Formats an HtmlNode into a PdfMake Node
 * @param {Object} matchedNode - Node match with key and node keys
 * @param {Object} doc Current PDFMake Document
 * @param $scope
 */
function formatNode(matchedNode, doc, $scope)
{
    var toReturn = {};
    var node = matchedNode.node;
    var key = matchedNode.key;
    if (!(node || key) || node.shouldSkip)
        return toReturn;
    
    // Marks node as having been processed and that formatNode should skip it if tried again
    node.shouldSkip = true;
    
    var sizeMod;
    var listType;
    switch (key)
    {
        case 'SPAN':
        case 'TD':
            var needsSkip = false;
            traverseNodes(node.childNodes, {nodeTypes: [3]}, function (matched) {
                if (matched.shouldSkip)
                    needsSkip = true;
                
                matched.shouldSkip = true
            });
            
        case 3:
            if (needsSkip) return toReturn;
            toReturn.fontSize = doc.defaultStyle.fontSize;
            styleNode(node, toReturn, $scope);
            break;
        
        case 'IMG':
            var image;
            var link;
            
            if (node.alt && Object.keys(doc.images).includes(node.alt))
            {
                image = node.alt;
                link = node.src;
            }
            else if (node.parentNode && node.parentNode.nodeName === 'A' && node.parentNode.href)
            {
                var match = Object.keys(doc.images).find(function(imageId)
                {
                    return node.parentNode.href.includes(imageId)
                });
                if (match)
                {
                    image = match;
                    link = node.parentNode.href;
                }
            }
            
            if (image)
            {
                styleNode(node, toReturn, $scope);
                delete toReturn.text;
                
                toReturn.alignment = 'center';
                toReturn.image = image;
                
                if (link)
                    toReturn.link = replaceLinkRefs(link, $scope.pdfBaseUrl);
            }
            
            break;
            
        case 'OL':
            listType = 'ol';
        case 'UL':
            listType = listType || 'ul';
            
            toReturn.alignment = 'left';
            toReturn[listType] = [];
            
            for (var i = 0; i < node.children.length; i++)
            {
                var itemNode = node.children[i];
                if (itemNode.childNodes.length)
                {
                    var textNode = {};
                    itemNode.childNodes[0].shouldSkip = true;
                    styleNode(itemNode.childNodes[0], textNode, $scope);
                    toReturn[listType].push(textNode);
                }
            }
            break;
        
        case 'TR':
            var childNodes = [];
            var columns = (node.children.length);
            var tableNode = new TableNode(0, columns);
            traverseNodes(node.childNodes, {
                nodeTypes: [3], nodeNames: ['UL', 'OL']
            }, function (match, key) { childNodes.push({node: match, key: key}) });
            
            var rowIndex;
            
            var x = childNodes.map(function(node) {
                    var toReturn =  formatNode(node, doc, $scope);
                    node.node.shouldSkip = true;
                    return toReturn;
                })
                .filter(function (cellNode) { return isValidNode(cellNode)});
            
                x.forEach(function (cellNode, index)
                {
                    
                    var columnIndex = index;
                    if (columnIndex === 0) rowIndex = (rowIndex) ? rowIndex + 1 : 0;
                    
                    var getIndex = [];
                    getIndex.push((rowIndex < tableNode.getRowCount()) ? rowIndex : tableNode.getIndexSize()[0]);
                    getIndex.push((columnIndex < tableNode.getColumnCount()) ? columnIndex : tableNode.getIndexSize()[1]);
                    
                    tableNode.editItem(getIndex, function(node)
                    {
                       node.push(cellNode);
                        if (cellNode.fillColor)
                            node.fillColor = cellNode.fillColor;
                    });
                    
            });
            
            toReturn = tableNode.getTableCell();
            toReturn.table.widths =  [150, 75];
            toReturn.layout = 'logbook';
            
            doc.extra.tableCount += 1;
            
            break;
    }
    
    return toReturn;
}

/**
 * Styles a PdfMake node based on the node provided
 * @param node - Original HtmlNode
 * @param textNode - PdfMake node to style
 * @param $scope - Project Scope
 * @param preventSiblingChecking - Used to determine if the node is part of another styleNode chain
 */
function styleNode(node, textNode, $scope, preventSiblingChecking)
{
    preventSiblingChecking = preventSiblingChecking || false;
    
    // Adds text to the node if it does not exist
    if (!textNode.text || !textNode.text.trim().length)
        textNode.text = node.textContent.trimLeft();
    
    if (preventSiblingChecking)
        textNode.text = node.textContent;
    
    textNode.hadAlignment = false;
    textNode.alignment = 'left';
    
    var styling = node.parsedStyling;
    if (styling && textNode.text && textNode.text.length > 0 )
    {
        styling.nodeName.forEach(function(nodeName)
        {
            var sizeMod;
            switch (nodeName)
            {
                case 'EM':
                    textNode.italics = true;
                    break;
        
                case 'STRONG':
                case 'B':
                    textNode.bold = true;
                    break;
        
                case 'H1':
                    sizeMod = 1;
                case 'H2':
                    sizeMod = sizeMod || 2;
                case 'H3':
                    sizeMod = sizeMod || 3;
                case 'H4':
                    sizeMod = sizeMod || 4;
                case 'H5':
                    sizeMod = sizeMod || 5;
                case 'H6':
                    sizeMod = sizeMod || 6;
            
                    textNode.color = '#317EAC';
                    textNode.bold = true;
            
                    if (textNode.fontSize)
                        textNode.fontSize += (7 - sizeMod);
            }
        });
        
        styling.classList.forEach(function(className)
        {
            if (className === 'glyphicon-unchecked')
                textNode.text = '☐';
            if (className === 'glyphicon-checked')
                textNode.text = '☑';
    
            if (className === 'bold')
                textNode.bold = true;
            if (className === 'italic')
                textNode.italics = true;
    
            if (className === 'text-danger')
                textNode.color = '#b94a48';
            if (className === 'text-success')
                textNode.color = '#468847';
            if (className === 'text-warning')
                textNode.color = '#c09853';
            if (className === 'text-muted')
                textNode.color = '#98978b';
            if (className === 'text-primary')
                textNode.color = '#325d88';
            if (className === 'text-info')
                textNode.color = '#29abe0';
        });
        
        if (styling.href)
        {
            textNode.color = '#2FA4E7';
            textNode.link = replaceLinkRefs(styling.href, $scope.pdfBaseUrl);
        }
        
        styling.attributes.forEach(function(attribute)
        {
            switch(attribute.name)
            {
                case 'align':
                    if (textNode.hadAlignment) break;
                    
                    textNode.alignment = attribute.value;
                    break;
                    
                case 'noteid':
                    if (!(styling.href && textNode.link)) break;
    
                    var note = $scope.notes.find(function(note)
                    {
                        var value = node.parentNode.attributes.getNamedItem('noteId').nodeValue;
                        return note.id == value;
                    });
                    if (note)
                    {
                        textNode.link += `#/note-detail?noteId=${note.id}&log=${$scope.selectedLog.id}`;
                    }
                    break;
            }
        });
    
        for (var attrib in styling.styleOptions)
        {
            switch (attrib)
            {
                case 'text-align':
                    if (!textNode.hadAlignment) textNode.alignment = styling.styleOptions[attrib];
                    textNode.hadAlignment = true;
                    break;
                case 'background-color':
                    if (textNode.fillColor)
                        break;
                    var colors = [];
                    var exp = /(\d)+/g;
                    var match = exp.exec(styling.styleOptions[attrib]);
                
                    while (match)
                    {
                        colors.push(match[0]);
                        match = exp.exec(styling.styleOptions[attrib]);
                    }
                    if (colors.length >= 3)
                        textNode.fillColor = [colors[0], colors[1], colors[2]];
                    break;
                case 'font-weight':
                    if (styling.styleOptions[attrib] === 'bold')
                        textNode.bold = 'true';
            }
        }
    }
    
    // Fallback for if styling options are not parsed
    if (textNode.text && textNode.text.length > 0 && !styling)
        traverseParents(node, [
        
        new MatchPair(function(parent)
        {
            return !!(parent.style && getCssStyleMapSize(parent.style));
        },
            function(matchingNode)
        {
            var styleOptions = {};
            for (var i = 0; i < getCssStyleMapSize(matchingNode.style); i++)
            {
                var key = matchingNode.style[i];
                styleOptions[key] = matchingNode.style[key];
            }
            
            for (var attrib in styleOptions)
            {
                switch (attrib)
                {
                    case 'text-align':
                        if (!textNode.hadAlignment) textNode.alignment = styleOptions[attrib];
                        textNode.hadAlignment = true;
                        break;
                    case 'background-color':
                        if (textNode.fillColor)
                            break;
                        var colors = [];
                        var exp = /(\d)+/g;
                        var match = exp.exec(styleOptions[attrib]);
                        
                        while (match)
                        {
                            colors.push(match[0]);
                            match = exp.exec(styleOptions[attrib]);
                        }
                        if (colors.length >= 3)
                            textNode.fillColor = [colors[0], colors[1], colors[2]];
                        break;
                    case 'font-weight':
                        if (styleOptions[attrib] === 'bold')
                            textNode.bold = 'true';
                }
            }
            
            var style = matchingNode.attributes.getNamedItem('style');
            if (style)
            {
                if (style.value.toLowerCase().includes('font-weight: bold')) {
                    textNode.bold = 'true'
                }
            }
        }),
        
        // Matching for Parents NodeNames
        new MatchPair(function(parent)
        {
            return (['EM', 'B', 'STRONG', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6'].includes(parent.nodeName))
        },
            function (matchingNode)
        {
            var sizeMod;
                switch (matchingNode.nodeName)
                {
                    case 'EM':
                        textNode.italics = true;
                        break;
                        
                    case 'STRONG':
                    case 'B':
                        textNode.bold = true;
                        break;
    
                    case 'H1':
                        sizeMod = 1;
                    case 'H2':
                        sizeMod = sizeMod || 2;
                    case 'H3':
                        sizeMod = sizeMod || 3;
                    case 'H4':
                        sizeMod = sizeMod || 4;
                    case 'H5':
                        sizeMod = sizeMod || 5;
                    case 'H6':
                        sizeMod = sizeMod || 6;
                        
                        textNode.color = '#317EAC';
                        textNode.bold = true;
                        
                        if (textNode.fontSize)
                            textNode.fontSize += (7 - sizeMod);
                }
            }),
        
        // Matching for Parents Classes
        new MatchPair(function (parent)
        {
            return (parent.classList && parent.classList.length)
        },
            function (matchingNode)
        {
            if (matchingNode.classList.contains('glyphicon-unchecked'))
                textNode.text = '☐';
            if (matchingNode.classList.contains('glyphicon-checked'))
                textNode.text = '☑';
            
            if (matchingNode.classList.contains('bold'))
                textNode.bold = true;
            if (matchingNode.classList.contains('italic'))
                textNode.italics = true;
            
            if (matchingNode.classList.contains('text-danger'))
                textNode.color = '#b94a48';
            if (matchingNode.classList.contains('text-success'))
                textNode.color = '#468847';
            if (matchingNode.classList.contains('text-warning'))
                textNode.color = '#c09853';
            if (matchingNode.classList.contains('text-muted'))
                textNode.color = '#98978b';
            if (matchingNode.classList.contains('text-primary'))
                textNode.color = '#325d88';
            if (matchingNode.classList.contains('text-info'))
                textNode.color = '#29abe0';
            
        }),
        
        // Matching for Hrefs
        new MatchPair(function (parent)
        {
            return (parent.href)
        },
            function(matchingNode)
        {
            textNode.color = '#2FA4E7';
            textNode.link = matchingNode.href;
        }),
        
        // Matching for attributes
        new MatchPair(function (parent)
        {
            return (parent.attributes && ['align'].some(function(attrib)
            {
                return parent.attributes.getNamedItem(attrib)
            }))
        },
            function(matchingNode)
        {
            for (var i = 0; i < matchingNode.attributes.length; i++)
            {
                var attrib = matchingNode.attributes.item(i);
                switch (attrib.name)
                {
                    case 'align':
                        if (!textNode.hadAlignment)
                            textNode.alignment = attrib.value;
                        textNode.hadAlignment = true;
                        break;
                }
            }
        })
    ]);
    
    //Traversing parents for oor styling
    traverseParents(node, [
        new MatchPair((parent) => {
            if (!parent.attributes && !parent.classList) return;
            
            if (parent.attributes) {
                const attrs = parent.attributes;
                if (attrs.getNamedItem('data-oor-cell') || attrs.getNamedItem('data-template-comment'))
                    return true;
            }
            if (parent.classList) {
                for (const value of parent.classList.values()) {
                    if (value === 'template-comment')
                        return true;
                }
            }
        }, () => {
            if (textNode.link)
                textNode.color = '#005590';
            textNode.fillColor = '#fef7b2';
        })
    ]);
    
    // Formatting for noteId linking
    // Uses fallthrough from link formatting
    if (node.parentNode.attributes.getNamedItem('noteId') && node.parentNode.href)
    {
        var note = $scope.notes.find(function(note)
        {
            var value = node.parentNode.attributes.getNamedItem('noteId').nodeValue;
            return note.id == value;
        });
        if (note)
        {
            textNode.link += `#/note-detail?noteId=${note.id}&log=${$scope.selectedLog.id}`;
        }
    }
    
    
    
    if (!(textNode.text || textNode.text.trim().length))
        return;
    
    if (typeof textNode.text === 'string')
        textNode.text = textNode.text.replace(/<[^>]*>?/gm, '');
    
    if (!preventSiblingChecking && node.nextSibling && ['EM', 'B', 'STRONG'].some(function (nodeName)
    {
        if (node.nextSibling.nodeName && node.nextSibling.nodeName == nodeName)
        {
            return true;
        }
        else if (node.nextSibling.nodeType === 3)
        {
            return (node.nextSibling.textContent.trim().length)
        }
        return false;
    }))
    {
        var original = Object.assign({}, textNode);
        textNode.text = [original];
        var sibling = node.nextSibling;
        while (sibling)
        {
            sibling.shouldSkip = true;
            traverseNodes(sibling.childNodes,  { nodeTypes: [3] }, function (node) { node.shouldSkip = true; });
            
            var newNode = {
                fontSize:original.fontSize
            };
            styleNode(sibling, newNode, $scope, true);
            
            if (isValidNode(newNode))
                textNode.text.push(newNode);
            
            sibling = (sibling.nextSibling && ['EM', 'B', 'STRONG'].some(function (nodeName)
            {
                if (sibling.nextSibling.nodeName && sibling.nextSibling.nodeName == nodeName)
                {
                    return true;
                }
                else if (sibling.nextSibling.nodeType === 3)
                {
                    return (sibling.nextSibling.textContent.trim().length)
                }
                return false;
            })) ? sibling.nextSibling : undefined;
        }
    }
    
    // Regular Expression for Emoji matching
    var exp = /\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g;
	var match;
	
    if (Array.isArray(textNode.text))
    {
        textNode.text.forEach(function(node)
        {
            match = exp.exec(node.text);
            if (match) {
                node.text = emojiSplitter(node)
            }
        });
    }
    else
    {
        match = exp.exec(textNode.text);
        if (match) {
            textNode.text = emojiSplitter(textNode)
        }
    }
}

/**
 * Split TextNodes into Emoji separated nodes
 * @param textNode
 * @param {String}textNode.text
 * @returns {{text: *}[]}
 */
function emojiSplitter(textNode)
{
    var exp = /\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g;
    var splitStr = textNode.text.split(exp)
        .map(function(/*String*/str)
        {
            var toReturn = Object.assign({}, textNode);
            toReturn.text = str;
            return toReturn;
        });
    var match = exp.exec(textNode.text);
    if (!match) return splitStr;
    
    var indexes = Object.keys(splitStr);
    var index = 0;
    while (match)
    {
        splitStr.splice(indexes[index] + 1, 0, {text: match[0], font: 'Unicode'});
        index += 1;
        match = exp.exec(textNode.text);
    }
    return splitStr.filter(function(textNode) { return isValidNode(textNode) });
}

function isValidNode(node)
{
    return !!(node.image || (node.text && ((Array.isArray(node.text) && node.text.length) || (!Array.isArray(node.text) && node.text.trim().length))) || node.ul || node.ol || node.table);
}


function replaceLinkRefs(baseString, newBaseUrl) {
    let newString = baseString;
    
    // Replace window origin with new Base URL.
    if (typeof newBaseUrl === 'string' && newBaseUrl.length) {
        newBaseUrl = newBaseUrl.replace(/\/$/g, '');
        newString = baseString.replace(window.location.origin, newBaseUrl);
    }
    
    // Replace API file references to navigate to files controller
    return newString.replace('api/files/', "#/files?fileId=");
}

/**
 * Goes through the provided CSS Style map and gets the size of the used style options.
 * @param {CSSStyleDeclaration} styleDeclaration
 * @returns {number} Size of used style options
 */
function getCssStyleMapSize(styleDeclaration)
{
    var size = 0;
    for (var field in styleDeclaration)
    {
        if (!isNaN(field)) size++;
        else
            break;
    }
    return size;
}

function getCssStyleMap(node)
{
    var styleOptions = { length: 0 };
    if (!node.style) return styleOptions;
    styleOptions.length = getCssStyleMapSize(node.style);
    for (var i = 0; i < styleOptions.length; i++)
    {
        var key = node.style[i];
        styleOptions[key] = node.style[key];
    }
    return styleOptions;
}

/**
 * PdfMake TableNode
 * @param rows Number of Rows
 * @param columns Number of Columns
 * @constructor
 */
function TableNode(rows, columns)
{
    rows = rows || 1;
    columns = columns || 1;
    
    // Access body[row][column];
    var _body = [];
    var self = this;
    
    var setTable = function()
    {
        _body = [];
        for (var row = 0; row < rows; row++)
        {
            self.addRow();
        }
    };
    
    this.getColumnCount = function () { return columns; };
    this.getRowCount = function () { return _body.length; };
    
    /**
     * Sets an object into the location in the table
     * @param {Number[]} at - Index array of where the content should be inserted
     * @param {(Object|String)} content - Item to place into the table
     *
     * @return {Boolean} Whether the insertion was successful
     */
    this.replaceItem = function (at, content)
    {
        at = at || [-1, -1];
        if ((at[0] >= this.getRowCount() || at[0] < 0 || at[1] >= columns || at[1] < 0) && !content)
        {
            return false;
        }
        _body[at[0]][at[1]] = new StackNode([content]);
        return true;
    };
    
    /**
     * Adds a row with the Data provided
     * @param {Object[]=} dataSet - Array of cells to add as Stacks.
     * Ex; ['Hello', 'World'], two columns; [['Hello', 'World'], 'Goodbye'], two columns with text stacks in the first.
     *
     * @param {Function=} customizer - Calls the function with the new node and index as params
     */
    this.addRow = function(dataSet, customizer)
    {
        dataSet = (dataSet && Array.isArray(dataSet)) ? dataSet : [];
        var rowIndex = _body.push([]) - 1;
        
        for (var i = 0; i < columns; i++)
        {
            _body[rowIndex].push((dataSet[i]) ? new StackNode([dataSet[i]]) : new StackNode());
            if (customizer)
                customizer(_body[rowIndex][i], [rowIndex, i])
        }
    };
    
    this.removeRow = function(index)
    {
        // Protect against removing all rows. One is required.
        if (_body.length <= 1)
            return false;
        
        _body.splice(index, 1);
        return true;
    };
    
    this.editItem = function(at, func)
    {
        at = at || [-1, -1];
        if ((at[0] >= this.getRowCount() || at[0] < 0 || at[1] >= columns || at[1] < 0) && !func)
            return;
        
        func(_body[at[0]][at[1]]);
    };
    
    /**
     * Removes rows that contain only empty nodes from the table
     */
    this.trim = function ()
    {
        var toTrim = [];
        _body.forEach(function (value, index)
        {
            var needsTrim = value.every(function(stackNode)
            {
                return stackNode.length() < 1;
            });
            
            if (needsTrim)
                toTrim.push(index);
        });
        
        for (var i = toTrim.length - 1; i > -1; i--)
        {
            this.removeRow(toTrim[i]);
        }
    };
    
    /**
     * Creates a table cell to insert into PdfMake
     * @param {Object=} formatOptions - Currently unused
     * @returns {{table: {body: *}}}
     */
    this.getTableCell = function(formatOptions)
    {
        return {
            layout: 'noBorders',
            table: {
                widths: function()
                {
                    var widths = [];
                    for (var i = 0; i < self.getColumnCount(); i++)
                    {
                        widths.push('*')
                    }
                    return widths;
                }(),
                
                body: this.getBody()
            }
        };
    };
    
    /**
     * Returns a clone of the body of the array
     * @returns {*[]}
     */
    this.getBody = function()
    {
        return _body.slice(0);
    };
    
    /**
     * Returns the size of the table expressed as an array. [# of rows, # of columns]
     * @returns {[Number, Number]}
     */
    this.getSize = function()
    {
        return [this.getRowCount(), this.getColumnCount()];
    };
    
    /**
     * Returns the last indexes of the current table; [rowIndex, columnIndex]
     * @returns {[Number, Number]}
     */
    this.getIndexSize = function()
    {
        var sizes = this.getSize();
        return [sizes[0] - 1, sizes[1] - 1];
    };
    
    this.isEmpty = function ()
    {
        var toReturn = true;
        for (var row = 0; row < this.getRowCount(); row++)
        {
            for (var column = 0; column < columns; column++)
            {
                var node = _body[row][column];
                if (node.peek()) return false;
            }
        }
        return toReturn;
    };
    
    /**
     * @callback TableNodeCellCallBack
     * @param {Object} value
     * @param {Number[]} index
     */
    /**
     * @param {TableNodeCellCallBack} callback
     */
    this.forEach = function(callback)
    {
        var body = this.getBody();
        for (var row = 0; row < this.getRowCount(); row++)
        {
            for (var column = 0; column < columns; column++)
            {
                callback(body[row][column], [row, column]);
            }
        }
    };
    
    setTable();
}

/**
 * PdfMake Stack Node
 * @param {Array=} stack - initial stack
 * @constructor
 */
function StackNode(stack)
{
    this.stack = (Array.isArray(stack)) ? stack : [];
    
    this.push = function (node)
    {
        this.stack.push(node);
        return this;
    };
    
    this.pop = function ()
    {
        return this.stack.pop();
    };
    
    this.peek = function()
    {
        if (this.stack.length)
            return this.stack[this.stack.length - 1];
    };
    
    this.forEach = function(func)
    {
        this.stack.forEach(function(value)
        {
            func(value)
        });
    };
    
    this.length = function() { return this.stack.length }
}

export { formatPDF };